import React, { useEffect, useContext, useState, useActionState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Text_Long from '../ERUMAUI/UI_Input_Text_Long';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Button from '../ERUMAUI/UI_Button';

export default function Subwindow_ScheduleManagement_Attendees({ zIndex, isActive, id }) {
    const UI = useContext(Context_UI);
    const { Template_List } = useTemplating();
    const { Buildings, Floors, Rooms, Map_Composition } = useMapRenderer();
    const { Reservation, Reservation_Set } = useScheduleManagement();
    const Close = () => {
        UI.Subwindows_Close(id);
    }

    useEffect(() => {
        UI.Element_Focus("Input_Attendees");
    }, [])

    const Handle_Add = async () => {
        const Passed = await UI.Input_Evaluate([
            {
                Type: "Text",
                ID: "Input_Attendees",
                AC: ""
            }
        ]);

        if (Passed) {
            // Grab the current input value
            const Value = UI.Element_Value_Get("Input_Attendees");

            Reservation_Set(prev => ({
                ...prev,
                Activity: {
                    ...prev.Activity,
                    Attendees: {
                        ...prev.Activity.Attendees,
                        Names: [...prev.Activity.Attendees.Names, Value],
                        Count: prev.Activity.Attendees.Count + 1
                    }
                }
            }));

            UI.Element_Value_Set("Input_Attendees", "");
            UI.Element_Focus("Input_Attendees");
        }
    };

    const Handle_Remove = (index) => {
        Reservation_Set(prev => {
            const updatedNames = prev.Activity.Attendees.Names.filter((_, i) => i !== index);
            return {
                ...prev,
                Activity: {
                    ...prev.Activity,
                    Attendees: {
                        ...prev.Activity.Attendees,
                        Names: updatedNames,
                        Count: prev.Activity.Attendees.Count - 1
                    }
                }
            };
        });
    };

    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    List of attendees
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Close}>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content style={{ minHeight: "500px", paddingRight: "10px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "auto 1fr auto", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                    <UI_Input_Text
                        Label_Text="Add a new attendee:"
                        Input_Placeholder="Dela Cruz, Juan"
                        id="Input_Attendees" />
                    <UI_Button
                        Text="Add"
                        Icon={<UI_Icon Name="Add" />}
                        Icon_Position="Left"
                        OnClick={Handle_Add}
                    />
                </div>
                {Reservation?.Activity?.Attendees?.Names.length > 0 ?
                    <div className='SM_List'>
                        {Reservation?.Activity?.Attendees?.Names.map((Item, Index) => (
                            <div className='SM_List_Item'>
                                <p className='General_Paragraph'>
                                    {Item}
                                </p>
                                <UI_Button
                                    Icon={<UI_Icon Name="Remove" />}
                                    Icon_Position="Center"
                                    OnClick={() => Handle_Remove(Index)}
                                />
                            </div>
                        ))}
                    </div>
                    :
                    <p className='General_Paragraph' style={{textAlign: "center"}}>
                        The list is empty.
                    </p>
                    
                }
                

            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Close}>
                    Close
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
